import React, { memo, useRef, useState, useEffect } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddBoxIcon from "@material-ui/icons/AddBox";
import { Alert } from '@material-ui/lab';
import {
    Box,
    Button,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Grid,
    IconButton,
    makeStyles,
    Typography
} from "@material-ui/core";
import theme from '../../styles/theme';
import useStyles from '../../styles/styles';
import useTrafficStyles from "../../styles/trafficStyles";
import TrafficSourceOfferInput from "../TrafficSource/TrafficSourceOfferInput";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

const useExpanderListStyle = makeStyles({
    root: {
        border: '1px solid',

        '& .MuiExpansionPanelSummary-root': {
            padding: theme.spacing(0, 2, 0, 1),
        },
    },
    default: {
        display: 'block'
    },
    removeButton: {
        cursor: 'pointer',
        pointerEvents: 'all'
    },
});


const SubOfferTable = memo(({
    data,
    creatingNew,
    editView,
    handleInputChange,
    handleSwitchChange,
    offerInputs,
    setOfferInputs,
    defaultOfferInputs,
    setDefaultOfferInputs,
    findOfferById,
    findAdvertiserById,
}) => {
    const classes = useStyles();
    const expandClasses = useExpanderListStyle();
    const trafficClasses = useTrafficStyles();
    const [expandedPanelsArr, setExpandedPanelsArr] = useState([]);

    useEffect(() => {
        if(!creatingNew && data.offer){
            addExistingOffers(data.offer.subOfferIds, data.offer.advertiserId)
        }
    }, [data])

    const addExistingOffers = (subOfferIds, advertiserId) => {
        const list = []
        subOfferIds.forEach(subOfferId => {
            const offer = findOfferById(data.allOffer, subOfferId)
            const input = {offerId: offer.offerId, offerName: offer.offerName, advertiserId: advertiserId}
            list.push(input)
        })
        setOfferInputs([...list])
        setDefaultOfferInputs([...list])
    }

    const addOfferRow = (offerId = null, offerName = null, advertiserId = null) => {
        const input = {offerId: offerId, offerName: offerName, advertiserId: advertiserId}
        setOfferInputs([
            ...offerInputs,
            input
        ]);
    }

    const setInput = (input, id) => {
        const offer = findOfferById(data.allOffer, input.offerId)
        offerInputs[id] = {offerId: offer.offerId, offerName: offer.offerName, advertiserId: offer.advertiserId}
        setOfferInputs([...offerInputs])
    }

    return (
        <>
            <Box display="flex" justifyContent={"space-between"} style={{ marginBottom: '5px' }}>
                <Typography variant="body1" align="left" gutterBottom>
                    Add Sub Offers below.
                </Typography>
                {creatingNew || editView ? (
                    <Button
                        variant="contained"
                        className={classes.addButton}
                        onClick={() => addOfferRow()}
                        size="small"
                    >
                        Add Offer <AddBoxIcon/>
                    </Button> )
                : null }
            </Box>
            {!offerInputs.length ? (
                <Alert severity="warning">
                    There are no Offers at this time.
                </Alert>
            ) : (
               <>
                   {offerInputs.map((item, idx) => {
                        const isExpanded = expandedPanelsArr.length ? expandedPanelsArr.includes(idx) : false;
                        return (
                            <ExpansionPanel 
                                key={idx.toString()}
                                id={`multi-offer-${idx}`}
                                expanded={isExpanded}
                                disabled={!editView}
                                className={expandClasses.root}
                                onChange={(e, bool) => {
                                    // Only disable expansion if we aren't creating new AND we find it in the default inputs (existing sub offers)
                                    if(!creatingNew && defaultOfferInputs.find(elem => elem.offerId === item.offerId)){
                                        return
                                    }

                                    if (bool) {
                                        setExpandedPanelsArr(expandedPanelsArr => [...expandedPanelsArr, idx]);
                                    } else {
                                        if (expandedPanelsArr.includes(idx)) {
                                            setExpandedPanelsArr(expandedPanelsArr.filter(panel => panel !== idx));
                                        }
                                    }
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                  <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={3}
                                    >
                                        <Grid container key={idx.toString()} style={{ margin: '10px 0'}}>
                                            <Grid item xs={12} md={3}>
                                                <Box display="flex" flexDirection="row" alignItems="center">
                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                        <IconButton
                                                            className={expandClasses.removeButton}
                                                            onClick={(e) => {
                                                                if(editView) {
                                                                    e.stopPropagation();
                                                                    offerInputs.splice(idx, 1)
                                                                    setOfferInputs([...offerInputs])
                                                                }
                                                                // deleteRow(idx);
                                                            }}>
                                                            <RemoveCircleIcon/>
                                                        </IconButton>
                                                    </Box>
                                                    <Box textAlign="left">
                                                        <Typography variant="caption">
                                                            {isExpanded ? 'Close Sub Offer' : 'Edit Sub Offer'}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={9}>
                                                <Box display="flex" flexDirection="row" alignItems="center" height="100%">
                                                    <Box>
                                                        {offerInputs[idx].offerName}
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <TrafficSourceOfferInput
                                        item={item}
                                        handleSwitchChange={handleSwitchChange}
                                        handleInputChange={handleInputChange}
                                        setInputs={(data) => setInput(data, idx)}
                                        data={data}
                                        offerId={item.offerId}
                                        advertiserId={item.advertiserId}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                       );
                    })}
                </>
            )}  
        </>
    )
});

export default SubOfferTable;